import { render } from "./FindFriends.vue?vue&type=template&id=00be549c"
import script from "./FindFriends.vue?vue&type=script&lang=js"
export * from "./FindFriends.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/happy-quiz-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__